export const iconFontAwesomeSecuritySkullCrossbones = (
	<i className="fa-solid fa-skull-crossbones"></i>
);
